<template>
    <div class="troubleshoot-area">
        <custom-checkbox
            class="ml-2"
            :readOnly="readOnly"
            :label="label"
            :color="'red'"
            :value="!!check"
            @check-value-change="onCompletedChange"
        />
        <div class="px-2">
            <comments
                v-if="isChecked"
                ref="comments2"
                :comments="comments || {}"
                :clearable="clearable"
                :editMode="editMode"
                :rules="editMode ? rules: []"
                @new-comment="onNewComment"
            />
            <image-section
                v-if="!noImages"
                v-show="isChecked"
                ref="local-image-section"
                :label="'Ανέβασμα Φωτογραφιών'"
                :uploadedPhotos="uploadedPhotos || []"
                :editMode="editMode"
                :readOnly="readOnly"
                :clearable="clearable"
                :uploadPath="uploadPath"
                @photoSelection="onPhotoSelection"
                :title="photoLabel"
            />
        </div>
    </div>
</template>
<script>
    import ImageSection from '@/components/ImageSection'
    import CustomCheckbox from '@/components/CustomCheckBox'
    import Comments from '@/components/Comments'

    export default {
        components: { ImageSection, CustomCheckbox, Comments },
        props: {
            photoLabel: {
                type: String,
                required: false,
                default: () => { return 'Φωτογραφίες' }
            },
            noImages: {
                type: Boolean,
                required: false,
                default: () => { return false }
            },
            label: {
                type: String,
                required: true
            },
            check: {
                type: Boolean,
                required: true
            },
            comments: {
                type: Object,
                required: true
            },
            uploadedPhotos: {
                type: Array,
                required: false
            },
            readOnly: {
                type: Boolean,
                required: true
            },
            editMode: {
                type: Boolean,
                required: true
            },
            clearable: {
                type: Boolean,
                required: true
            },
            uploadPath: {
                type: String,
                required: false
            }
        },
        watch: {
            check: {
                handler(newVal, oldVal) {
                    this.isChecked = newVal
                }
            }
        },
        data() {
            return {
                isChecked: false,
                newComment: null,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ]
            }
        },
        methods: {
            onCompletedChange(e) {
                this.isChecked = e
            },
            onNewComment(e) {
                this.newComment = e
            },
            async uploadPhotos() {
                const uploadedTroubleshootingPhotos = await this.$refs['local-image-section'].uploadPhotos()
                return uploadedTroubleshootingPhotos
            },
            async deleteUploadedPhotos() {
                const deletedTroubleshootingPhotos = await this.$refs['local-image-section'].deleteUploadedPhotos()
                return deletedTroubleshootingPhotos
            },
            getIssueValues() {
                return {
                    checked: this.isChecked,
                    newComment: this.newComment
                }
            },
            clear() {
                this.newComment = null
                if (this.$refs['comments2']) {
                    this.$refs['comments2'].clear()
                }
            },
            onPhotoSelection(selectedPhotos) {
                this.$emit('onIssuePhotoSelection', selectedPhotos.length)
            }
        }
    }

</script>
<style scoped>
.troubleshoot-area {
    display: flex;
    flex-direction: column;
}

.field {
    padding: 0.5rem;
}
</style>
